import script from "./LiquidityUpdateModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./LiquidityUpdateModal.vue?vue&type=script&setup=true&lang=ts"

import "./LiquidityUpdateModal.vue?vue&type=style&index=0&id=cafee7a6&scoped=true&lang=css"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cafee7a6"],['__file',"LiquidityUpdateModal.vue"]])

export default __exports__